var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.version
    ? _c(
        "div",
        [
          _vm.coupon
            ? _c("PaidWeb", {
                staticClass: "not-mobile",
                attrs: {
                  version: _vm.version,
                  coupon: _vm.coupon,
                  planData: _vm.planData,
                  price: _vm.price
                },
                on: { closeDetail: _vm.closeDetail }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("PaidMobile", {
            staticClass: "is-mobile",
            attrs: {
              version: _vm.version,
              planData: _vm.planData,
              coupon: _vm.coupon,
              price: _vm.price
            },
            on: { closeDetail: _vm.closeDetail }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }